import { useQuery, gql } from "@apollo/client";

import { Currency, useCurrencies } from "@zapier/currency";
import { useCurrentAccountId } from "@zapier/identity";
import { AccountCurrencyQuery } from "@/types";

export const accountCurrencyQuery = gql`
  query accountCurrencyQuery($accountId: Int!) {
    account(id: $accountId) {
      id
      currency
    }
  }
`;

export const useAccountCurrency = () => {
  const accountId = useCurrentAccountId();
  const { currencies, isLoading: isCurrenciesLoading } = useCurrencies({
    useQuery,
  });

  const { data, error, loading } = useQuery<AccountCurrencyQuery>(
    accountCurrencyQuery,
    {
      skip: !accountId,
      variables: { accountId },
    }
  );

  return {
    // Get the full currency object
    currency: currencies?.find(
      (c: Currency) => c.name === data?.account?.currency
    ),
    error: error ? "There was an issue loading data." : undefined,
    isLoading: loading || isCurrenciesLoading,
  };
};
